import { useState } from "react";
import { faqs } from "@/mocks/guagua";
import SectionHeading from "./SectionHeading";

function Faq() {
  const [open, setOpen] = useState<number>(0);

  const toggle = (idx: number) => setOpen((prev) => (prev === idx ? -1 : idx));

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="你可能想问的"
          desc="关于内容来源、更新频率、版权与订阅等高频问题，这里一并为你解答。"
        />

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={faq.question}
                className="overflow-hidden rounded-2xl border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => toggle(idx)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-3 text-sm md:text-base font-medium text-foreground-800">
                    <span
                      className={`grid h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-primary-100 text-primary-700"
                      }`}
                    >
                      {idx + 1}
                    </span>
                    {faq.question}
                  </span>
                  <i
                    className={`ri-add-line shrink-0 text-xl text-foreground-400 transition-transform ${isOpen ? "rotate-45" : ""}`}
                    aria-hidden="true"
                  ></i>
                </button>
                {isOpen && (
                  <div className="border-t border-background-100 px-5 py-4">
                    <p className="pl-10 text-sm leading-relaxed text-foreground-600">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Faq;